import { clamp, cx } from "./utils";

export interface LevelMeterProps {
  /** Current RMS level in 0–1. */
  rms: number;
  /** Peak-hold level in 0–1. */
  peak?: number;
  /** Lights the red clip indicator (sample hit ±1.0). */
  clipped?: boolean;
  /** Render as a vertical bar. */
  vertical?: boolean;
  /** Accessible name. @default "输入电平" */
  label?: string;
  className?: string;
}

/** Input level meter with a peak marker and a clipping indicator. */
export function LevelMeter({
  rms,
  peak,
  clipped = false,
  vertical = false,
  label = "输入电平",
  className,
}: LevelMeterProps) {
  const r = clamp(rms, 0, 1);
  const p = peak != null ? clamp(peak, 0, 1) : null;
  return (
    <div
      className={cx(
        "xz-meter",
        vertical && "xz-meter--vertical",
        clipped && "is-clipped",
        className,
      )}
      role="meter"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(r * 100)}
      aria-valuetext={clipped ? "已削波" : `${Math.round(r * 100)}%`}
    >
      <div className="xz-meter__track">
        <div
          className="xz-meter__fill"
          style={vertical ? { height: `${r * 100}%` } : { width: `${r * 100}%` }}
        />
        {p != null && (
          <div
            className="xz-meter__peak"
            style={vertical ? { bottom: `${p * 100}%` } : { left: `${p * 100}%` }}
          />
        )}
      </div>
      <span className={cx("xz-meter__clip", clipped && "is-on")} title="削波" aria-hidden="true" />
    </div>
  );
}
